export const LIST_PRICE_SHOW_EDIT_POPUP = 'LIST_PRICE_SHOW_EDIT_POPUP';
export const LIST_PRICE_SHOW_CREATE_POPUP = 'LIST_PRICE_SHOW_CREATE_POPUP';

export const LIST_PRICE_HIDE_ALL_POPUPS = 'LIST_PRICE_HIDE_ALL_POPUPS';
